define.alias("shared/components/shared/mobile/drawer/feature-drawer", "media/components/shared/mobile/drawer/feature-drawer");